exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-5608800e] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.delete-warning-msg[data-v-5608800e],\n.delete-itr-msg[data-v-5608800e] {\n  font-size: 14px;\n  line-height: 130%;\n  color: #1b1e22;\n  width: 356px;\n  text-align: left;\n}\n.delete-warning-msg[data-v-5608800e] {\n  color: #6f7680;\n  margin-top: 24px;\n}\n.delete-child-list[data-v-5608800e] {\n  font-size: 14px;\n  line-height: 130%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  color: #53585f;\n  margin-top: 24px;\n}\n.delete-child-list div[data-v-5608800e]:last-child {\n  margin-left: 8px;\n}\n", ""]);

// exports
